import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import '../../styles/components.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/dashboard" className="navbar-logo">
            🏥 Farmacias AKOFAR
          </Link>
        </div>

        <div className="navbar-menu">
          <Link to="/dashboard" className="navbar-item">
            📊 Dashboard
          </Link>
          <Link to="/ventas" className="navbar-item">
            💰 Ventas
          </Link>
          <Link to="/productos" className="navbar-item">
            📦 Productos
          </Link>
          <Link to="/inventario" className="navbar-item">
            📋 Inventario
          </Link>
        </div>

        <div className="navbar-user">
          <div className="user-info" onClick={toggleUserMenu}>
            <span className="user-icon">👤</span>
            <span className="user-name">{user?.username || 'Usuario'}</span>
            <span className="user-arrow">{showUserMenu ? '▲' : '▼'}</span>
          </div>

          {showUserMenu && (
            <div className="user-dropdown">
              <div className="dropdown-item">
                <span className="dropdown-label">Rol:</span>
                <span className="dropdown-value">{user?.rol || 'N/A'}</span>
              </div>
              <div className="dropdown-item">
                <span className="dropdown-label">Farmacia:</span>
                <span className="dropdown-value">{user?.farmacia_nombre || 'N/A'}</span>
              </div>
              <div className="dropdown-divider"></div>
              <button 
                className="dropdown-button logout-button" 
                onClick={handleLogout}
              >
                🚪 Cerrar Sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

// Made with Bob
